module.exports = __webpack_public_path__ + "img/el-0-b-3572-ok-copy-2.d625a6b8.jpg";